module.exports = __webpack_public_path__ + "e6b1b341dde65ef5b4175e600b154935.svg";